import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendSignInLinkToEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { useToast } from "./ui/use-toast";

export default function EmailSignIn() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const actionCodeSettings = {
      //url: 'http://localhost:3000/verify', 
      //url: 'http://192.168.1.58:3000/verify',
      url: 'https://alumni.waynemanor.org/verify', // TODO: Update this to our veri page URL
      handleCodeInApp: true,
    };
    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      toast({
        title: "Email Sent",
        description: "Check your email for the sign-in link!",
        duration: 5000,
      });
      setEmail('');
    } catch (error) {
      console.error('Error sending email link:', error);
      toast({
        title: "Error",
        description: "Failed to send sign-in link. Please try again.",
        variant: "destructive",
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="w-[350px] mx-auto mt-10">
      <CardHeader>
        <CardTitle>Sign In</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSignIn}>
          <div className="grid w-full items-center gap-4">
            <div className="flex flex-col space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>
        </form>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button onClick={handleSignIn} disabled={isLoading}>
          {isLoading ? "Sending..." : "Send Sign-In Link"}
        </Button>
      </CardFooter>
    </Card>
  );
}